export default __webpack_public_path__ + "static/media/2.5d6dc5cd.jpg";